export function PauseIcon({
  className = "size-12",
}: {
  className?: string;
}) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="7.19995" y="3.60001" width="14.4" height="40.8" rx="3.6" fill="white" />
      <rect x="26.4" y="3.60001" width="14.4" height="40.8" rx="3.6" fill="white" />
    </svg>
  );
}
export const displayName = "PauseIcon";
